import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { MatIcon } from '@angular/material/icon';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { MatButton } from '@angular/material/button';
import { CompanyProductPhase } from 'src/app/models/company_product_phase.model';

@Component({
  selector: 'app-company-product-phase-detail',
  templateUrl: './company-product-phase-detail.component.html',
  styleUrls: ['./company-product-phase-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTabNav, MatButton, MatTabLink, RouterLinkActive, RouterLink, MatTabNavPanel, RouterOutlet, MatIcon],
})
export class CompanyProductPhasesDetailComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);
  protected router = inject(Router);
  permissions = inject(PermissionsService);
  private api = inject(ApiService);

  navLinks: any[];
  activeLinkIndex = 0;
  title: string = '';
  company_product_title: string = '';
  company_product_id: number | undefined;
  company_product_phase: CompanyProductPhase | undefined;
  queryParams: Record<string, string> = {};

  ngOnInit(): void {
    this.setNavLinks();
    this.initCompanyProduct();
    this.initCompanyProductPhase();
    this.router.events.subscribe(res => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => this.router.url.includes(tab.link)));
      this.setTitle();
    });
    this.listenQueryParams();
  }

  private setNavLinks() {
    this.navLinks = [
      {
        label: 'Backlog',
        link: 'backlog',
        index: 0,
        queryParamGroup: 0,
      },
      {
        label: 'Tableros',
        link: 'boards',
        index: 2,
        queryParamGroup: 1,
      },
    ];

    this.setTitle();
  }

  private setTitle() {
    this.title = this.navLinks[this.activeLinkIndex]?.label;
  }

  private initCompanyProduct() {
    this.company_product_id = +(
      this.activatedRoute.snapshot.paramMap.get('company_product_id') ??
      this.activatedRoute.snapshot.parent?.paramMap.get('company_product_id') ??
      this.activatedRoute.snapshot.parent?.parent?.paramMap.get('company_product_id') ??
      this.activatedRoute.snapshot.paramMap.get('id') ??
      this.activatedRoute.snapshot.parent?.paramMap.get('id') ??
      (this.activatedRoute.snapshot.parent?.parent?.paramMap.get('id') as string)
    );
    if (this.company_product_id) {
      this.api.getCompanyProduct(this.company_product_id.toString(), { select: 'title' }).subscribe(data => {
        this.company_product_title = data.title;
      });
    }
  }

  private initCompanyProductPhase() {
    const company_product_phase_id = +(this.activatedRoute.snapshot.paramMap.get('phase_id') as string);
    if (!isNaN(company_product_phase_id)) {
      this.api.getCompanyProductPhase(company_product_phase_id).subscribe(data => {
        this.company_product_phase = data;
        if (this.company_product_phase.enable_roadmap) {
          this.navLinks.splice(1, 0, {
            label: 'Roadmap',
            link: 'roadmap',
            index: 1,
            queryParamGroup: 0,
          });
        }
      });
    }
  }

  private listenQueryParams() {
    this.activatedRoute.queryParamMap.subscribe((data: any) => {
      const params = { ...data.params };

      if (params.from != null) delete params.from;
      if (params.to != null) delete params.to;

      this.queryParams = params;
    });
  }
}
